import {
  reUploadImages,
  uploadPicture,
  getDiagnosisByUUID,
} from "js/redux/actions/diagnoses";
import React, { useRef, useState } from "react";
import useModal from "./useModal";
import { useParams } from "react-router-dom";

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import LoaderDiv from "./LoaderDiv";
import close from "../../../assets/icons/close.svg";
import trash from "../../../assets/icons/delete.svg";
import upload from "../../../assets/icons/upload.svg";

import { toast } from "react-toastify";

function ReUpload({
  message,
  uploadPicture,
  reUploadImages,
  getDiagnosisByUUID,
  t,
}) {
  const [Modal, openModal, closeModal] = useModal();
  const [uploading, setUploading] = useState(false);
  const { consultationId } = useParams();
  const closeupRef = useRef(null);
  const overviewRef = useRef(null);
  const [closeupImg, setCloseupImg] = useState(null);
  const [overviewImg, setOverviewImg] = useState(null);

  const notify = () => toast.info("Images has been uploaded");

  const reUpload = async () => {
    setUploading(true);
    const closeupResponse = await uploadPicture(closeupImg);
    const overviewResponse = await uploadPicture(overviewImg);
    await reUploadImages({
      closeup: closeupResponse.data.image,
      overview: overviewResponse.data.image,
      uuid: consultationId,
    });
    setUploading(false);
    await getDiagnosisByUUID(consultationId);
    closeModal();
    notify();
  };

  const handleButtonClick = (component) => {
    if (component === "closeup") {
      // Trigger the file input click event
      closeupRef.current.click();
    } else {
      overviewRef.current.click();
    }
  };

  const handleFileChange = (event, component) => {
    const fileObj = event.target.files[0];
    if (fileObj) {
      if (component === "closeup") {
        setCloseupImg(fileObj);
      } else {
        setOverviewImg(fileObj);
      }
    }
  };

  const reUploadModal = () => {
    return (
      <Modal>
        <div className="upload-photos-modal">
          <div className="modal-header">
            <span>Reupload images</span>
            <img src={close} alt="close" onClick={() => closeModal()} />
          </div>
          <div className="modal-subheader">
            High-quality images help doctors make a better & accurate diagnosis
          </div>
          <div className="modal-content">
            <div className="modal-image-content">
              <span>Upload a close-up photo</span>
              <div
                className="photo-container"
                onClick={() => handleButtonClick("closeup")}
              >
                {closeupImg ? (
                  <div className="photo-container-uploaded">
                    <div className="photo-container-delete">
                      <img
                        src={trash}
                        alt="delete"
                        onClick={() => {
                          setCloseupImg(null);
                        }}
                      />
                    </div>
                    <img
                      src={URL.createObjectURL(closeupImg)}
                      alt="upload"
                      className="photo-container-img"
                    />
                  </div>
                ) : (
                  <div className="photo-container-content">
                    <input
                      type="file"
                      accept="image/*"
                      ref={closeupRef}
                      style={{ display: "none" }}
                      onChange={(e) => handleFileChange(e, "closeup")}
                    />
                    <img src={upload} alt="upload" className="upload-img" />
                    <span className="photo-text">Upload image</span>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-image-content">
              <span>Upload an overview photo</span>
              <div
                className="photo-container"
                onClick={() => handleButtonClick("overview")}
              >
                {overviewImg ? (
                  <img
                    src={URL.createObjectURL(overviewImg)}
                    alt="upload"
                    className="photo-container-img"
                  />
                ) : (
                  <div className="photo-container-content">
                    <input
                      type="file"
                      accept="image/*"
                      ref={overviewRef}
                      style={{ display: "none" }}
                      onChange={(e) => handleFileChange(e, "overview")}
                    />
                    <img src={upload} alt="upload" className="upload-img" />
                    <span className="photo-text">Upload image</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <button
            className="upload-button"
            onClick={reUpload}
            disabled={!closeupImg || !overviewImg}
            style={{
              backgroundColor:
                closeupImg && overviewImg ? "#4D4557" : "#0000008F",
            }}
          >
            {uploading ? <LoaderDiv /> : "Upload"}
          </button>
        </div>
      </Modal>
    );
  };
  return (
    <>
      <div className="action-required-tagline">
        <span className="message-doctor-heading">
          {t("summary.doctor_message")}
        </span>
        <span className="message-doctor-text">{message}</span>
        <button onClick={() => openModal()} className="action-required-button">
          <img src={upload} alt="download" className="download-img" />
          {t("summary.upload_photos")}
        </button>
      </div>
      {reUploadModal()}
    </>
  );
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {
  uploadPicture,
  reUploadImages,
  getDiagnosisByUUID,
})(withTranslation()(ReUpload));
